import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import {
  Box,
  Container,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import TopBar from "../../../components/TopBar/TopBar";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  getClinicPets,
  updatePetStatusById,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import { getPetSearchType } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";

const tblHeaders = [
  "patientId",
  "petName",
  "breed",
  "gender",
  "userName",
  "status",
  "chat",
  "book",
];
const nameExpan = {
  patientId: "Patient ID",
  userName: "User Name",
  petName: "Pet Name",
  breed: "Breed",
  gender: "Gender",
  chat: "",
  book: "",
};

const ClinicPetsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalBookVisible, setBookModVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectPet, setSelectPet] = useState(null);
  const [createModVisible, setCreateModalVisible] = useState(false);
  const [page, setPage] = useState(1);
  const pets = useSelector((state) => state?.pet?.clinicPets);
  const itemSize = 10;
  const defaultUrl = `?type=all&page=1&itemSize=${itemSize}`;

  useEffect(() => {
    dispatch(
      getClinicPets(
        `?type=all${getPetSearchType(searchValue)}&page=1&itemSize=${itemSize}${
          searchValue?.length > 0 ? `&search=${searchValue}` : ""
        }`
      )
    );
    setPage(1);
  }, [searchValue]);

  const bookAppointment = (li) => {
    setSelectPet(li);
    setBookModVisible(true);
  };

  const handleCreate = () => {
    setCreateModalVisible(true);
  };

  const getClinicPetsData = () => {
    setSearchValue("");
    dispatch(getClinicPets(defaultUrl));
  };

  const onCloseCreateMod = (e) => {
    if (e === "petCreated") getClinicPetsData();
    setCreateModalVisible(!createModVisible);
  };

  const handleClickPet = (pet) => {
    return navigate("/clinic-pet-details", {
      state: {
        appointment: {
          appoinment: {
            appointmentId: pet?.appointmentId ?? null,
            petId: pet?.listOfDatas?.petId,
          },
        },
        inpatientId: pet?.inpaitentId,
      },
    });
  };

  const onClickMessageIcon = (e) => {
    dispatch(createNewChat(e?.userId)).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const updatePetStatus = (petId, status) => {
    dispatch(updatePetStatusById({ petId, status })).then((res) => {
      if (res?.payload) {
        dispatch(
          getClinicPets(
            `?type=all${getPetSearchType(
              searchValue
            )}&page=1&itemSize=${itemSize}${
              searchValue?.length > 0 ? `&search=${searchValue}` : ""
            }`
          )
        );
      }
    });
  };

  const getTableRecords = () => {
    if (pets?.pets?.length === 0 || !pets?.pets) return [];
    return pets?.pets?.map((pt) => {
      const pet = pt?.listOfDatas;
      return {
        appointmentId: pt?.appointmentId,
        inpaitentId: pt?.inpaitentId,
        patientId: pet?.oldPatientId
          ? pet?.oldPatientId?.split(".").shift()
          : "-",
        userName: (
          <Custom3dotString
            str={pet?.userName}
            className="font-medium fs14"
            length={15}
          />
        ),
        petName: (
          <div onClick={() => handleClickPet(pt)}>
            <Custom3dotString
              str={pet?.petName}
              className="font-bold fs14 cursor blue-color underline"
              length={15}
            />
          </div>
        ),
        breed: pet?.breed,
        gender: (
          <Typography
            className={`capitalize font-medium fs12 ${
              pet?.gender === "male" ? "card-blue-color" : "card-rose-color"
            }`}
          >
            {pet?.gender}
          </Typography>
        ),
        status: (
          <CustomSwitch
            value={pet.status}
            onChange={(e) => updatePetStatus(pet?.petId, !pet?.status)}
            greenToGray
          />
        ),
        chat: (
          <MessageOutlinedIcon
            className="img-wh35 yellow-color cursor"
            onClick={() => onClickMessageIcon(pet)}
          />
        ),
        book: (
          <div style={{ width: 100 }}>
            <CustomButton
              text="Book"
              onClick={() => bookAppointment(pet)}
              smallBtn
            />
          </div>
        ),
        userId: pet?.userId,
      };
    });
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getClinicPets(
        `?type=all${getPetSearchType(
          searchValue
        )}&page=${selectedPage}&itemSize=${itemSize}${
          searchValue?.length > 0 ? `&search=${searchValue}` : ""
        }`
      )
    );
    setPage(selectedPage);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearchValue(e.target.value)}
                      value={searchValue}
                      backgroundColor={AppColors.lightPink}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={2}
                    md={2}
                    lg={1}
                    xl={1}
                    className="ml20"
                  >
                    <CustomButton text="Create" onClick={handleCreate} />
                  </Grid>
                  <div className="top-row-right-con w15Per topBar-select flex-end">
                    <Typography className="font-medium fs16">
                      Number of Pets: {pets?.totalRecords ?? 0}
                    </Typography>
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
        </Container>
      </TopBar>

      <Box className="pb-40 ph20">
        <TableContainer sx={{ maxHeight: 450 }} className="mb20">
          <Table
            sx={{ minWidth: 200 }}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {tblHeaders?.map((hdr, i) => (
                  <TableCell
                    key={i}
                    style={tblGrayBack}
                    className={`table-header-text`}
                  >
                    <div
                      style={{
                        width:
                          hdr === "userName" || hdr === "petName"
                            ? 200
                            : hdr === "chat"
                            ? 80
                            : hdr === "breed"
                            ? 150
                            : 100,
                      }}
                    >
                      {nameExpan?.[hdr]}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {pets?.pets?.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} className="text-align-center h100">
                  <div className="no-rec">No records available</div>
                </TableCell>
              </TableRow>
            )}
            <TableBody>
              {getTableRecords()?.map((li, i) => {
                return (
                  <TableRow key={i}>
                    {tblHeaders?.map((hdr, ind) => (
                      <TableCell key={ind + i + "tr"} component="th">
                        <div
                          style={{
                            width:
                              hdr === "userName" || hdr === "petName"
                                ? 200
                                : hdr === "chat"
                                ? 80
                                : hdr === "breed"
                                ? 150
                                : 100,
                          }}
                        >
                          {li?.[hdr]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
            {Math.ceil(pets?.totalRecords / itemSize) > 1 ? (
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={12}>
                    <div className="flex-end">
                      <Pagination
                        count={Math.ceil(pets?.totalRecords / itemSize)}
                        variant="outlined"
                        color="primary"
                        page={page}
                        onChange={handleChangePage}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableFooter>
            ) : null}
          </Table>
        </TableContainer>
      </Box>

      {modalBookVisible ? (
        <BookAnAppointment
          modalVisible={modalBookVisible}
          setBookModVisible={setBookModVisible}
          selectedPet={selectPet}
        />
      ) : null}
      {createModVisible ? (
        <CreateClinicPet
          createModVisible={createModVisible}
          onCloseCreateMod={onCloseCreateMod}
          setBookModVisible={setBookModVisible}
          setSelectPet={setSelectPet}
        />
      ) : null}
    </>
  );
};

export default ClinicPetsTable;
